import { Component, Input } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-progress-bar',
  templateUrl: './lex-progress-bar.component.html',
  styleUrls: ['./lex-progress-bar.component.scss'],
  standalone: false,
})
export class LexProgressBarComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() value: number;
  @Input() color: string;
}
